module.exports = __webpack_public_path__ + "static/media/2_r_lanos_79.06_81.2.5436c1e2.png";